import { createFileRoute } from "@tanstack/react-router";
import Auth from "@/pages/Auth";
import { buildNoindexHead, noindexLoader, type NoindexSEO } from "@/lib/noindex-route-seo";

const TITLES: NoindexSEO = {
  "es": "Iniciar sesión",
  "pt-BR": "Entrar",
  "en": "Sign in",
  "en-EU": "Sign in",
};

export const Route = createFileRoute("/auth")({
  loader: noindexLoader,
  head: ({ loaderData }) => buildNoindexHead(TITLES, "/auth", loaderData),
  component: Auth,
});
